import DownloadModel from '../models/downloadModel';
import { getMenhirUrl } from './config';

export function waitForDownload(uuid, infos = {}, toast, t) {
    return new DownloadModel({}).getInfo({ ...infos, uuid }).then(data => {
        if (data.data_info instanceof Blob) {
            // We received a pdf file instead of some json. This happens when opening legacy
            // menhir download urls.
            const url = URL.createObjectURL(data.data_info);
            openUrl(url);
            toast.success(t('ticket.accounting.modal.downloaded'));
            setTimeout(() => window.URL.revokeObjectURL(url), 0);
        } else if (data.data_info.ready) {
            // The download is ready, we open the pdf file in a new tab
            const menhirUrl = getMenhirUrl();
            if (menhirUrl) {
                openUrl(`${menhirUrl}/downloadFile?${uuid}`);
                toast.success(t('ticket.accounting.modal.downloaded'));
            } else {
                toast.error(t('ticket.accounting.modal.downloadError'));
            }
        } else {
            setTimeout(() => {
                waitForDownload(uuid, infos, toast, t);
            }, 2000);
        }
    });
}

function openUrl(href) {
    var link = document.createElement('a');
    link.href = href;
    link.target = '_blank';
    link.click();
}

export default function download(getUrl, infos = {}, toast, t) {
    return getUrl()
        .then(response => waitForDownload(response.data_url.uuid, infos, toast, t))
        .catch(error => {
            console.error(error);
            toast.error(t('ticket.accounting.modal.downloadError'));
        });
}
